import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dashboard-abeilles',
  templateUrl: './dashboard-abeilles.component.html',
  styleUrls: ['./dashboard-abeilles.component.scss']
})
export class DashboardAbeillesComponent implements OnInit {

  constructor() {}

  ngOnInit() {
  }

}
